import { render, staticRenderFns } from "./ControlIdInit.vue?vue&type=template&id=a530c75e"
import script from "./ControlIdInit.vue?vue&type=script&lang=js"
export * from "./ControlIdInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports